module.exports = __webpack_public_path__ + "static/media/CISectionBHole.efdbc502.png";